(() => {
  const selectors = [
    'h1','h2','h3','h4','h5','h6',
    '.hce-heading','.hce-hero__title','.hce-store__title',
    '.card__heading','.product__title','.collection-hero__title'
  ].join(',');

  const measurer = document.createElement('span');
  Object.assign(measurer.style, {
    position: 'fixed',
    visibility: 'hidden',
    pointerEvents: 'none',
    whiteSpace: 'nowrap',
    left: '-99999px',
    top: '-99999px'
  });

  function getLongestWord(text) {
    return (text || '')
      .trim()
      .split(/\s+/)
      .filter(Boolean)
      .sort((a,b) => b.length - a.length)[0] || '';
  }

  function fitHeading(el) {
    if (!el || !el.isConnected) return;
    el.style.removeProperty('font-size');
    const cs = getComputedStyle(el);
    const word = getLongestWord(el.textContent);
    if (!word) return;

    const available = el.clientWidth - parseFloat(cs.paddingLeft || 0) - parseFloat(cs.paddingRight || 0);
    if (available <= 0) return;

    if (!measurer.isConnected) document.body.appendChild(measurer);
    measurer.style.fontFamily = cs.fontFamily;
    measurer.style.fontWeight = cs.fontWeight;
    measurer.style.fontStyle = cs.fontStyle;
    measurer.style.letterSpacing = cs.letterSpacing;
    measurer.style.textTransform = cs.textTransform;
    measurer.style.fontSize = cs.fontSize;
    measurer.textContent = word;

    const wordWidth = measurer.getBoundingClientRect().width;
    if (wordWidth <= available) return;

    const base = parseFloat(cs.fontSize) || 16;
    const scaled = Math.max(14, Math.floor(base * (available / wordWidth) * 0.97 * 10) / 10);
    el.style.fontSize = `${scaled}px`;
  }

  function fitAll() {
    document.querySelectorAll(selectors).forEach(fitHeading);
  }

  let raf;
  function scheduleFit() {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(fitAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleFit, { once: true });
  } else {
    scheduleFit();
  }
  window.addEventListener('load', scheduleFit, { once: true });
  window.addEventListener('resize', scheduleFit, { passive: true });

  if ('ResizeObserver' in window) {
    const ro = new ResizeObserver(scheduleFit);
    document.addEventListener('DOMContentLoaded', () => {
      document.querySelectorAll(selectors).forEach(el => ro.observe(el));
    }, { once: true });
  }
})();
